module.exports = __webpack_public_path__ + "img/1561279554.092bda77.jpg";